import React, { useEffect, useState } from "react";
import { useProductGroupCategory } from "../../../../api/product-group-category/use-product-group-category";
import Button from "../../../../components/ui/Button/Button";
import { Dropdown } from "../../../../components/ui/Dropdown/Dropdown";
import InputDate from "../../../../components/ui/InputDate/InputDate";
import InputSearch from "../../../../components/ui/InputSearch/InputSearch";

const checkByOptions = [
  {
    id: "name",
    name: "상품명",
  },
  {
    id: "productGroupName",
    name: "상품 그룹명",
  },

  {
    id: "productNo",
    name: "상품번호 표시",
  },
];

function Filter(props) {
  const {
    onFilter,
    onSubmitFilter,
    onResetFilter,
    onChangeSearchBy,
    onChangeSearchByValue,
    filter,
  } = props;
  const { data: categories } = useProductGroupCategory();
  const categoriesData = [
    {
      id: "",
      name: "전체",
    },
    ...categories,
  ];
  const [discountStartDate, setDiscountStartDate] = useState(null);
  const [discountEndDate, setDiscountEndDate] = useState(null);
  const [selectedDateOption, setSelectedDateOption] = useState();

  const onChangeDiscountStartDate = (value) => {
    setDiscountStartDate(value);
    onFilter({
      ...filter,
      from: value?.startOf("day").valueOf(),
    });
  };

  const onChangeDiscountEndDate = (value) => {
    setDiscountEndDate(value);
    onFilter({
      ...filter,
      to: value?.endOf("day").valueOf(),
    });
  };
  const onChangeDateTo = (increment) => {
    if (discountEndDate !== null) {
      setSelectedDateOption(increment);
      if (increment === 0 || increment === 7) {
        const subtracted = discountEndDate.subtract(increment, "day");
        setDiscountStartDate(subtracted);
        onFilter({
          ...filter,
          from: subtracted?.startOf("day").valueOf(),
          to: discountEndDate?.endOf("day").valueOf(),
        });
      }
      if (increment === 30) {
        const subtracted = discountEndDate.subtract(1, "month");
        setDiscountStartDate(subtracted);
        onFilter({
          ...filter,
          from: subtracted?.startOf("day").valueOf(),
          to: discountEndDate?.endOf("day").valueOf(),
        });
      }
      if (increment === 90) {
        const subtracted = discountEndDate.subtract(3, "month");
        setDiscountStartDate(subtracted);
        onFilter({
          ...filter,
          from: subtracted?.startOf("day").valueOf(),
          to: discountEndDate?.endOf("day").valueOf(),
        });
      }
    }
  };

  return (
    <div
      style={{
        boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.16)",
      }}
      className="mb-8 mt-4 rounded-[4px] shadow-lg"
    >
      <div className="flex items-center px-5 pt-5 pb-[10px]">
        <div className="flex items-center">
          <span className="w-24">카테고리</span>
          <Dropdown
            options={categoriesData}
            onClickItem={(id) =>
              onFilter({
                ...filter,
                categoryId: id,
              })
            }
            placeholder="카테고리 선택"
          />
        </div>
      </div>

      <div className="flex items-center px-5 pb-5">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center w-1/2">
            <span className="w-24">검색</span>
            <div className="flex gap-4">
              <Dropdown
                width="w-28"
                placeholder="상품명"
                textColor="text-black"
                positionDropdown="top-10"
                options={checkByOptions}
                onClickItem={onChangeSearchBy}
              />
              <InputSearch onChange={(value) => onChangeSearchByValue(value)} />
            </div>
          </div>

          <div className="flex items-center gap-[8px] w-1/2">
            <span className="w-12">기간</span>
            <InputDate
              value={discountStartDate}
              onChange={onChangeDiscountStartDate}
              defaultValue={discountStartDate}
            />
            {" - "}
            <InputDate
              value={discountEndDate}
              onChange={onChangeDiscountEndDate}
              defaultValue={discountEndDate}
            />
            <div
              className={`border h-8 text-center rounded-[4px] border-button-grey flex divide-x text-[#bbbbbb]`}
            >
              <div
                onClick={() => onChangeDateTo(0)}
                className={`${
                  selectedDateOption === 0
                    ? "bg-primary-blue rounded-l-[4px] text-white"
                    : ""
                } py-2 w-[42px] m-auto cursor-pointer text-[10px]`}
              >
                오늘
              </div>
              <div
                onClick={() => onChangeDateTo(7)}
                className={`${
                  selectedDateOption === 7 ? "bg-primary-blue text-white" : ""
                } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
              >
                7일
              </div>
              <div
                onClick={() => onChangeDateTo(30)}
                className={`${
                  selectedDateOption === 30 ? "bg-primary-blue text-white" : ""
                } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
              >
                1개월
              </div>
              <div
                onClick={() => onChangeDateTo(90)}
                className={`${
                  selectedDateOption === 90
                    ? "bg-primary-blue rounded-r-[4px] text-white"
                    : ""
                } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
              >
                3개월
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-2.5 w-full border-t border-disable-grey " />
      <div className="pb-2.5 flex justify-center items-center">
        <Button
          onClick={onSubmitFilter}
          paddingButton="p-[4px]"
          width="w-[7rem]"
          className="border border-secondary-grey"
          text="필터 검색"
        />

        <Button
          onClick={onResetFilter}
          paddingButton="p-[4px]"
          width="w-[7rem]"
          className="border border-secondary-grey"
          text="필터 초기화"
        />
      </div>
    </div>
  );
}

export default Filter;
